// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-image {
  position: relative;
  overflow: hidden;
  background: #f6f7fb;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  display: block;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
}

.event-image.rounded {
  border-radius: 50%;
}

.event-image.square {
  border-radius: 12px;
}

.event-image.square-fluid {
  position: relative;
  padding-bottom: 100%;
  height: 0;
}

.event-image.square-fluid img,
.event-image.square-fluid .skeleton {
  position: absolute;
  inset: 0;
}

.event-image.square-fluid img {
  height: 100%;
}

.event-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity 160ms ease;
}

.event-image img.hidden {
  opacity: 0;
}

.event-image .skeleton {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, #f3f4f8 0px, #eceef4 40px, #f3f4f8 80px);
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/shared/src/lib/components/event-image/event-image.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2EAA2E;EAC3E,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".event-image {\n  position: relative;\n  overflow: hidden;\n  background: #f6f7fb;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n  display: block;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.event-image.rounded {\n  border-radius: 50%;\n}\n\n.event-image.square {\n  border-radius: 12px;\n}\n\n.event-image.square-fluid {\n  position: relative;\n  padding-bottom: 100%;\n  height: 0;\n}\n\n.event-image.square-fluid img,\n.event-image.square-fluid .skeleton {\n  position: absolute;\n  inset: 0;\n}\n\n.event-image.square-fluid img {\n  height: 100%;\n}\n\n.event-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: opacity 160ms ease;\n}\n\n.event-image img.hidden {\n  opacity: 0;\n}\n\n.event-image .skeleton {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, #f3f4f8 0px, #eceef4 40px, #f3f4f8 80px);\n  background-size: 200% 100%;\n  animation: shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: 200px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
